// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalSettings_root__3E8qf"};